import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SpecificationService } from '../../services/specification.service';
import { ExcelService } from 'src/app/shared/services/excel.service';
import { Subscription } from 'rxjs';
import { AddEditInvoiceSpecificationComponent } from './add-edit-invoice-specification/add-edit-invoice-specification.component';
import { SpecificationUploadComponent } from '../common/specification-upload/specification-upload.component';

@Component({
  selector: 'app-invoice-specification-list',
  templateUrl: './invoice-specification-list.component.html',
  styleUrls: ['./invoice-specification-list.component.scss'],
})
export class InvoiceSpecificationListComponent implements OnInit, OnDestroy {
  searchTerm: string = '';
  searchTermValue: string = '';
  onSpecUpdateAndCreation: boolean = false;
  showDeleteButton: boolean = false;
  specDeletionList = [];
  subscription = new Subscription();

  constructor(
    private dialog: MatDialog,
    private specificationService: SpecificationService,
    private excelService: ExcelService
  ) {}

  ngOnInit(): void {
    this.specificationService.invoiceSpecificationDeletionList.next([]);
    this.subscription.add(
      this.specificationService.invoiceSpecificationDeletionList.subscribe(list => {
        if (list.length) {
          this.specDeletionList = list;
          this.showDeleteButton = true;
        } else {
          this.specDeletionList = [];
          this.showDeleteButton = false;
        }
      })
    );
  }

  createSpecification() {
    const specificationDetailsCreateDialogRef = this.dialog.open(
      AddEditInvoiceSpecificationComponent,
      {
        disableClose: true,
        autoFocus: false,
        maxHeight: '100vh',
        maxWidth: '90vw',
        data: {
          action: 'create',
        },
      }
    );
    this.subscription.add(
      specificationDetailsCreateDialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.specificationService.onInvoiceSpecUpdateAndCreation.next(true);
        }
      })
    );
  }

  deleteSpecification() {
    this.specificationService.onInvoiceSpecDeleteClick.next(true);
  }

  searchSpecification(searchTerm: string) {
    this.searchTermValue = searchTerm;
  }

  editSpecEvent(spec: any) {
    const specValue = {
      specifications_id: spec?.specId,
      file_format: spec?.fileFormat,
    };
    const specificationDetailsCreateDialogRef = this.dialog.open(
      AddEditInvoiceSpecificationComponent,
      {
        disableClose: true,
        autoFocus: false,
        maxHeight: '100vh',
        maxWidth: '90vw',
        data: {
          action: 'update',
          spec: specValue,
        },
      }
    );
    this.subscription.add(
      specificationDetailsCreateDialogRef.afterClosed().subscribe(res => {
        if (res.value) {
          this.onSpecUpdateAndCreation = true;
        }
      })
    );
  }

  openUploadSpecification() {
    const uploadDialogRef = this.dialog.open(SpecificationUploadComponent, {
      disableClose: true,
      autoFocus: false,
      maxHeight: '90vh',
      maxWidth: '90vw',
    });
    uploadDialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.specificationService.extractJSONfromFile(res, data => {
          this.uploadSpecEvent(data);
        });
      }
    });
  }

  uploadSpecEvent(data) {
    const specificationDetailsCreateDialogRef = this.dialog.open(
      AddEditInvoiceSpecificationComponent,
      {
        disableClose: true,
        autoFocus: false,
        maxHeight: '100vh',
        maxWidth: '90vw',
        data: {
          action: 'upload',
          spec: data,
        },
      }
    );
    this.subscription.add(
      specificationDetailsCreateDialogRef.afterClosed().subscribe(res => {
        if (res.value) {
          this.specificationService.onInvoiceSpecUpdateAndCreation.next(true);
        }
      })
    );
  }

  downloadTemplateExcel(spec: any) {
    this.excelService.exportAsExcelFileWithHeader(
      spec?.data[0]?.csvColumns,
      spec?.specifications_id
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
